import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

const DRAW = 0.6
const LINE = 0.45
const GAP = 0.25
const HOLD = 0.2
const TRAVEL = DRAW + GAP

let mm

export const heartbeat = () => {

	if (mm) mm.revert()

	let rows = document.querySelectorAll('[data-animation="heartbeat"]')

	if (!rows.length) return

	mm = gsap.matchMedia()

	mm.add('(min-width: 961px) and (prefers-reduced-motion: no-preference)', () => {

		rows.forEach(row => {

			let start = row.querySelector('.pulse-line--start'),
				end = row.querySelector('.pulse-line--end'),
				spikes = row.querySelectorAll('.heartbeat path')

			if (!start || !end || !spikes.length) return

			let spikesAt = LINE + GAP,
				endAt = spikesAt + (spikes.length - 1) * TRAVEL + DRAW + GAP

			let sweep = gsap.timeline({ repeat: -1, repeatDelay: 0.4, paused: true, defaults: { ease: 'none' } })

			sweep
				.fromTo(start, { scaleX: 0, transformOrigin: 'left center' }, { scaleX: 1, duration: LINE }, 0)
				.set(start, { transformOrigin: 'right center' }, LINE + HOLD)
				.to(start, { scaleX: 0, duration: LINE }, LINE + HOLD)

				.fromTo(spikes, { drawSVG: '0% 0%' }, { drawSVG: '0% 100%', duration: DRAW, stagger: TRAVEL }, spikesAt)
				.to(spikes, { drawSVG: '100% 100%', duration: DRAW, stagger: TRAVEL }, spikesAt + DRAW + HOLD)

				.fromTo(end, { scaleX: 0, transformOrigin: 'left center' }, { scaleX: 1, duration: LINE }, endAt)
				.set(end, { transformOrigin: 'right center' }, endAt + LINE + HOLD)
				.to(end, { scaleX: 0, duration: LINE }, endAt + LINE + HOLD)

			ScrollTrigger.create({
				trigger: row,
				start: 'top bottom',
				end: 'bottom top',
				onToggle: self => self.isActive ? sweep.play() : sweep.pause(),
			})
		})
	})
}

export default () => { }
